// LegalDocs.jsx — Páginas legales de KIN (Privacidad, Términos, Cookies)
// Se muestran como modal desde el footer de LandingPage.

const FECHA = '18 de julio de 2026';

export const LEGAL_DOCS = {
  privacidad: {
    titulo: 'Política de Privacidad',
    secciones: [
      ['Quiénes somos', [
        'KIN (kin-map.com) es una plataforma de inteligencia de comercio exterior. Para cualquier asunto relacionado con tus datos personales puedes escribirnos a hola@kin-map.com.',
        'Tratamos los datos personales conforme a la Ley 1581 de 2012, el Decreto 1377 de 2013 y demás normas de protección de datos de la República de Colombia.',
      ]],
      ['Qué datos recogemos', [
        '• Datos de cuenta: tu correo electrónico y una contraseña. La contraseña se guarda cifrada mediante nuestro proveedor de autenticación (Supabase) y nunca es visible para nosotros.',
        '• Datos de suscripción: el plan que tienes (gratis o Pro) y su estado.',
        '• Datos de pago: los pagos se procesan directamente en MercadoPago. KIN no recibe ni almacena números de tarjeta ni datos financieros.',
        '• Datos técnicos mínimos necesarios para el funcionamiento del servicio.',
      ]],
      ['Para qué los usamos', [
        'Para prestarte el servicio, gestionar tu cuenta y tu suscripción, responder tus solicitudes y mejorar la plataforma.',
        'No vendemos, alquilamos ni compartimos tus datos personales con terceros para fines publicitarios.',
      ]],
      ['Sobre la información de comercio exterior', [
        'Las cifras de importaciones y exportaciones que muestra KIN provienen de registros públicos oficiales (DIAN) y de fuentes internacionales públicas (UN Comtrade, Banco Mundial, OMC). Esa información es de naturaleza pública y no corresponde a datos personales de nuestros usuarios.',
      ]],
      ['Proveedores que usamos', [
        '• Supabase — base de datos y autenticación de cuentas.',
        '• Vercel — alojamiento de la plataforma.',
        '• MercadoPago — procesamiento de pagos y suscripciones.',
        '• Anthropic (Claude) — generación de análisis con inteligencia artificial sobre datos de comercio; estas consultas no incluyen tus datos de cuenta.',
      ]],
      ['Tus derechos', [
        'Puedes conocer, actualizar, rectificar y suprimir tus datos, y revocar la autorización para su tratamiento, en cualquier momento. Escríbenos a hola@kin-map.com y atenderemos tu solicitud dentro de los plazos que establece la ley.',
      ]],
      ['Conservación y cambios', [
        'Conservamos tus datos mientras tu cuenta esté activa. Puedes solicitar la eliminación de tu cuenta y tus datos cuando quieras.',
        'Si modificamos esta política, publicaremos la versión actualizada en esta misma página.',
      ]],
    ],
  },

  terminos: {
    titulo: 'Términos de Uso',
    secciones: [
      ['El servicio', [
        'KIN es una plataforma que procesa registros públicos de comercio exterior (DIAN, UN Comtrade, OMC, Banco Mundial) y los presenta organizados, con indicadores y análisis, incluidos análisis generados con inteligencia artificial.',
      ]],
      ['Tu cuenta', [
        'Eres responsable de mantener la confidencialidad de tus credenciales y de la actividad realizada desde tu cuenta. Cada cuenta es personal.',
      ]],
      ['Planes y pagos', [
        'KIN ofrece un plan gratuito con acceso limitado y un Plan Pro de pago con acceso completo, a los precios publicados en la página de precios, cobrados en pesos colombianos a través de MercadoPago.',
        'La suscripción Pro se renueva automáticamente (mensual o anualmente, según el ciclo elegido). Puedes cancelarla en cualquier momento y conservarás el acceso Pro hasta el final del período ya pagado.',
        'Para solicitudes sobre pagos o reembolsos, escríbenos a hola@kin-map.com.',
      ]],
      ['Uso permitido', [
        'Puedes usar KIN para consultar información en beneficio de tu actividad comercial o profesional.',
        'No está permitido: extraer masivamente la base de datos (scraping), revender el acceso o los datos como producto propio, usar herramientas automatizadas para copiar el contenido, ni intentar vulnerar la seguridad de la plataforma.',
      ]],
      ['Exactitud de la información', [
        'La información proviene de fuentes oficiales y se procesa con el mayor cuidado; sin embargo, puede contener errores, omisiones o retrasos originados en la fuente. Los análisis generados con inteligencia artificial son orientativos.',
        'KIN no constituye asesoría legal, tributaria, aduanera ni financiera. Verifica la información relevante antes de tomar decisiones de negocio.',
      ]],
      ['Responsabilidad', [
        'El servicio se ofrece "tal cual". En la máxima medida permitida por la ley, KIN no responde por decisiones tomadas con base en la información de la plataforma ni por interrupciones temporales del servicio.',
      ]],
      ['Propiedad intelectual', [
        'El software, el diseño y la marca KIN son de nuestra propiedad. Los datos públicos pertenecen a sus respectivas fuentes oficiales.',
      ]],
      ['Terminación y ley aplicable', [
        'Podemos suspender cuentas que incumplan estos términos.',
        'Estos términos se rigen por las leyes de la República de Colombia. Contacto: hola@kin-map.com.',
      ]],
    ],
  },

  cookies: {
    titulo: 'Política de Cookies',
    secciones: [
      ['Lo esencial', [
        'KIN no usa cookies publicitarias ni rastreadores de terceros.',
        'Solo usamos almacenamiento técnico en tu navegador, indispensable para que la plataforma funcione:',
        '• Sesión de tu cuenta — para mantenerte conectado (gestionada por Supabase Auth).',
        '• Preferencia "Recordarme" — guarda tu correo en tu propio navegador para pre-llenarlo al iniciar sesión.',
      ]],
      ['Pagos', [
        'Al pagar, el proceso ocurre en el sitio de MercadoPago, que utiliza sus propias cookies bajo sus políticas.',
      ]],
      ['Cómo eliminarlos', [
        'Cierra sesión en KIN y borra los datos de sitio desde la configuración de tu navegador. Ten en cuenta que sin este almacenamiento técnico no es posible mantener tu sesión iniciada.',
      ]],
    ],
  },
};

export default function LegalModal({ doc, onClose }) {
  const d = LEGAL_DOCS[doc];
  if (!d) return null;
  return (
    <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(2,8,18,.82)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:'#0B1526', border:'1px solid rgba(255,255,255,.1)', borderRadius:16, maxWidth:760, width:'100%', maxHeight:'85vh', display:'flex', flexDirection:'column' }}>
        <div style={{ padding:'20px 28px', borderBottom:'1px solid rgba(255,255,255,.08)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div>
            <div style={{ fontSize:19, fontWeight:800, color:'#fff' }}>{d.titulo}</div>
            <div style={{ fontSize:12, color:'#64748B', marginTop:2 }}>Última actualización: {FECHA}</div>
          </div>
          <button onClick={onClose} aria-label="Cerrar" style={{ background:'none', border:'none', color:'#64748B', fontSize:22, cursor:'pointer', padding:6, lineHeight:1, fontFamily:'inherit' }}>✕</button>
        </div>
        <div style={{ padding:'22px 28px', overflowY:'auto' }}>
          {d.secciones.map(([titulo, parrafos]) => (
            <div key={titulo} style={{ marginBottom:22 }}>
              <div style={{ fontSize:14.5, fontWeight:700, color:'#0EA5A4', marginBottom:8 }}>{titulo}</div>
              {parrafos.map((p, i) => (
                <p key={i} style={{ fontSize:13.5, lineHeight:1.75, color:'rgba(255,255,255,.75)', margin:'0 0 8px', paddingLeft: p.startsWith('•') ? 10 : 0 }}>{p}</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
